import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import DoctorDetailsTable from "./DoctorDetailsTable";
import MapOnAppointment from "./MapOnAppointment";
import SearchInput from "../../../common/InlineSearch";
import { fetchQMEDoctorContacts } from "../../../services/ScheduleAppointmentApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { GetDoctorDetails } from "../../../services/StakeholderApi";

interface Location {
  fax: string;
  phone: string;
  email: string;
  locationname: string;
  locationaddress: string;
  latitude: number | null;
  longitude: number | null;
  count?: number;
}

const DoctorAppointmentMapLayout: React.FC = () => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const searchInputRef = useRef<any>(null);

  const [filteredLocations, setFilteredLocations] = useState<Location[]>([]);
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);
  const [QMEDoctorOptions, setQMEDoctorOptions] = useState<any[]>([]);
  const [filteredDoctors, setFilteredDoctors] = useState<
    typeof QMEDoctorOptions
  >([]);

  const searchKeys = ["contactFullName", "party"];

  // fetch all doctors
  const fetcQMEDoctors = async () => {
    try {
      const response = await fetchQMEDoctorContacts(Number(loggedInUserid));
      const filtered = Array.isArray(response)
        ? response.filter(
            (doc) => doc?.totalAppointmentsCount && doc.totalAppointmentsCount > 0
          )
        : [];
      setQMEDoctorOptions(filtered);
      setFilteredDoctors(filtered);
    } catch (error) {
      console.error("Error while fetching qme doctor schedule data:", error);
    }
  };

  // fetch doctor locations after selection
  const handleDoctorSelect = async (doctor: any) => {
    setSelectedDoctor(doctor);

    try {
      const dataList = await GetDoctorDetails(doctor.id);
      const rawLocationJson = dataList?.associatedLocations || [];

      const locationList: Location[] = rawLocationJson
        ?.filter((loc: any) => loc?.count)
        ?.map((loc: any) => ({
          fax: loc?.faxnumber || "NA",
          phone: loc?.phonenumber || "NA",
          email: loc?.emailaddress || "NA",
          locationname: loc?.locationname || "NA",
          locationaddress: loc?.locationaddress || "NA",
          latitude: loc?.latitude || null,
          longitude: loc?.longitude || null,
          count: loc?.count || 0,
        }));

      setFilteredLocations(locationList);
    } catch (err) {
      console.error("Error fetching doctor details:", err);
      setFilteredLocations([]);
    }
  };

  useEffect(() => {
    fetcQMEDoctors();
  }, []);

  const handleSearch = (query: string) => {
    if (!query) {
      setFilteredDoctors(QMEDoctorOptions);
      return;
    }

    const lowerQuery = query.toLowerCase();
    const results = QMEDoctorOptions.filter((doc) =>
      searchKeys.some((key) =>
        (doc as any)[key]?.toLowerCase().includes(lowerQuery)
      )
    );

    setFilteredDoctors(results);
  };

  return (
    <>
      <div className="main_wrapper_section pt-3">
        <Container fluid className="px-5">
          <Row>
            {/* Left side - Doctor details */}
            <Col md={4} className="setHeightFull">
              <h5 className="d-flex align-items-center border-bottom">
                <span
                  className="me-3"
                  style={{ lineHeight: "47px", width: "30%" }}
                >
                  Doctor Details
                </span>
                <div style={{ width: "70%" }} className="gridsearch">
                  <SearchInput
                    ref={searchInputRef}
                    data={QMEDoctorOptions}
                    searchKeys={searchKeys}
                    onSearchResult={setFilteredDoctors}
                    placeholder="Search"
                    onSearchQueryChange={handleSearch}
                    onInputChange={handleSearch}
                  />
                </div>
              </h5>
              <div className="doctype-appointmentcount">
                <DoctorDetailsTable
                  onDoctorSelect={handleDoctorSelect}
                  QMEDoctorOptions={filteredDoctors}
                />
              </div>
            </Col>

            {/* Right side - Map */}
            <Col md={8} className="setHeightFull">
              <h5 className="d-flex align-items-center border-bottom">
                <span className="me-3" style={{ lineHeight: "47px" }}>
                  Associated Locations
                </span>
              </h5>

              <MapOnAppointment locations={filteredLocations} />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default DoctorAppointmentMapLayout;
